<template>
  <div class="card">
    <a-modal
      title="ให้สิทธิผู้ดูแลระบบ"
      :visible="assigningRole.user"
      :confirm-loading="assigningRoleLoading"
      @ok="assignUser"
      @cancel="() => (assigningRole.user = null)"
    >
      <div v-if="assigningRole.user">
        <p class="text-md text-gray-700 font-light">ชื่อ - สกุล</p>
        <p class="text-base text-gray-900 font-medium">
          {{ assigningRole.user.firstname }} {{ assigningRole.user.lastname }}
        </p>
      </div>

      <div class="mt-4">
        <p class="text-md text-gray-700 font-light">ระดับการเข้าถึง</p>
        <a-radio-group v-model="assigningRole.role">
          <a-radio value="super_admin"> Super Admin </a-radio>
          <a-radio value="dashboard_admin"> Dashboard Admin </a-radio>
          <a-radio value="faculty_admin"> Faculty Admin </a-radio>
        </a-radio-group>
      </div>
    </a-modal>

    <div class="flex justify-end items-center w-full">
      <div>
        <p class="w-24">ค้นหารายชื่อ</p>
        <vue-suggestion
          class="z-20 w-full"
          :items="userSearchResults"
          v-model="assigningUser"
          :setLabel="setSearchLabel"
          :itemTemplate="SearchItem"
          @changed="userSearchChanged"
          @selected="userSelected"
        />
      </div>
    </div>

    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="Super Admin">
        <a-table
          :columns="adminColumns"
          :data-source="adminGroups.super_admins"
          :pagination="false"
        >
          <a slot="name" slot-scope="user"
            >{{ user.firstname }} {{ user.lastname }}
          </a>
          <a-button type="danger" slot="manage" slot-scope="user">
            ยกเลิกสิทธิ์
          </a-button>
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="2" tab="Dashboard Admin" force-render>
        <a-table
          :columns="adminColumns"
          :data-source="adminGroups.dashboard_admins"
          :pagination="false"
        >
          <a slot="name" slot-scope="user"
            >{{ user.firstname }} {{ user.lastname }}
          </a>
          <a-button type="danger" slot="manage" slot-scope="user">
            ยกเลิกสิทธิ์
          </a-button>
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="3" tab="Faculty Admin">
        <a-table
          :columns="facultyColumns"
          :data-source="data"
          :pagination="false"
        >
          <a slot="numberOfAdmin" slot-scope="faculty"
            >{{ faculty.admins.length }} คน</a
          >

          <router-link
            :to="{
              name: 'FacultyAdminManagement',
              params: { facultyId: faculty.id },
            }"
            slot="manage"
            slot-scope="faculty"
            >รายชื่อผู้ดูแล</router-link
          >
        </a-table>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import axios from "axios";
import SearchItem from "@/components/other/SearchItem";

export default {
  created() {
    this.fetchFaculties();
    this.fetchAdminGroups();
    this.fetchUsers();
  },
  data() {
    return {
      data: [],
      adminGroups: null,

      users: [],
      SearchItem,
      assigningRole: {
        user: null,
        role: null,
      },

      assigningRoleLoading: false,
      userSearchResults: [],
    };
  },
  methods: {
    async fetchUsers() {
      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URL}/user`,
      });

      this.users = response.data;
    },
    async fetchFaculties() {
      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URL}/faculty`,
      });

      this.data = response.data;
    },
    async fetchAdminGroups() {
      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URL}/role/user`,
      });

      this.adminGroups = response.data;
    },

    async assignUser() {
      const { role, user } = this.assigningRole;

      this.assigningRoleLoading = true;

      try {
        const response = await axios({
          method: "POST",
          url: `${process.env.VUE_APP_API_URL}/role/user/${user.id}`,
          data: {
            role,
          },
        });

        this.assigningRole = {
          user: null,
          role: null,
        };

        this.assigningRoleLoading = false;

        await this.fetchAdminGroups();
      } catch (error) {
        this.assigningRoleLoading = false;
      }
    },

    userSelected(user) {
      this.assigningRole.user = user;
    },
    setSearchLabel(item) {
      return `${item.firstname} ${item.lastname}`;
    },
    userSearchChanged(text) {
      this.userSearchResults = this.users.filter(
        (user) =>
          user.email.includes(text) ||
          user.firstname.includes(text) ||
          user.lastname.includes(text)
      );
    },
  },
  computed: {
    adminColumns() {
      return [
        {
          title: "ชื่อ - นามสกุล",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "หน่วยงาน",
          dataIndex: "faculty",
          key: "faculty",
        },
        {
          title: "จัดการ",
          scopedSlots: { customRender: "manage" },
        },
      ];
    },
    facultyColumns() {
      return [
        {
          title: "หน่วยงาน",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "จำนวนผู้ดูแล",
          scopedSlots: { customRender: "numberOfAdmin" },
        },
        {
          title: "จัดการ",
          scopedSlots: { customRender: "manage" },
        },
      ];
    },
  },
};
</script>

<style scope>
.vue-suggestion .vs__list {
  width: 100%;
  text-align: left;
  border: none;
  border-top: none;
  max-height: 400px;
  overflow-y: auto;
  border-bottom: 1px solid #9e76b4;
  position: relative;
}
.vue-suggestion .vs__list .vs__list-item {
  background-color: #fff;
  padding: 10px;
  border-left: 1px solid #9e76b4;
  border-right: 1px solid #9e76b4;
}
.vue-suggestion .vs__list .vs__list-item:last-child {
  border-bottom: none;
}
.vue-suggestion .vs__list .vs__list-item:hover {
  background-color: #eee !important;
}
.vue-suggestion .vs__list,
.vue-suggestion .vs__loading {
  position: absolute;
}
.vue-suggestion .vs__list .vs__list-item {
  cursor: pointer;
}
.vue-suggestion .vs__list .vs__list-item.vs__item-active {
  background-color: #f3f6fa;
}

input[type="search"] {
  width: 400px;
}
</style>
